@if (filters().length > 0) {
	<div class="flex items-start justify-between gap-2 pt-2 text-sm text-gray-500">
		<p>
			@if (showBothFiltersInfo()) {
				<span class="font-semibold">Access to higher education</span> degrees and
				<span class="font-semibold">part time</span> courses were removed from
				your search because those are unavailable during clearing.
			} @else if (showDegreeFilterInfo()) {
				<span class="font-semibold">Access to higher education</span> degrees were
				removed from your search because those are unavailable during clearing.
			} @else if (showModeFilterInfo()) {
				<span class="font-semibold">Part time</span> courses were removed from
				your search because those are unavailable during clearing.
			}
		</p>
		<button (click)="resetFilters()" type="button">
			<uc-close-modal-svg customStyles="w-4 h-4" />
		</button>
	</div>
}
